module.exports = __webpack_public_path__ + "static/media/Arial_Rounded_MT.ad6e0fcc.svg";